import * as protobuf from 'protobufjs/dist/minimal/protobuf.js';
export { protobuf as default };